<template>
  <v-row class="ma-0 pa-0 audience-pie-chart" justify="start">
    <v-col cols="12" class="ma-0 pa-0 audience-pie-chart__canvas">
      <v-chart class="chart" :option="graph_options" autoresize></v-chart>
    </v-col>
  </v-row>
</template>

<script>
import VChart, { THEME_KEY } from "vue-echarts";
import "echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { TitleComponent, TooltipComponent, LegendComponent } from "echarts/components";
import cpalette from "@/configs/ChartColors/get_color_palette";

use([CanvasRenderer, TitleComponent, TooltipComponent, LegendComponent]);

export default {
  name: "AudiencePieChart",
  props: ["chart_title", "chart_data", "color_palette"],
  provide: {
    [THEME_KEY]: "light",
  },
  components: {
    VChart,
  },
  computed: {
    formattedChartData: function () {
      return (this.chart_data || []).map((row) => ({
        name: row[0],
        value: Number(row[1]) || 0,
      }));
    },
    graph_options: function () {
      return {
        title: {
          text: this.chart_title,
          left: "center",
          top: 0,
          textStyle: {
            fontFamily: "Poppins",
            fontSize: 14,
            fontWeight: 600,
          },
        },
        color: cpalette.get_color_palette(this.color_palette || "cool"),
        tooltip: {
          trigger: "item",
          textStyle: {
            fontFamily: "Poppins",
          },
          formatter: function (param) {
            return `${param.name}: ${(Number(param.value) * 100).toFixed(1)}%`;
          },
        },
        legend: {
          show: true,
          type: "scroll",
          orient: "horizontal",
          left: "center",
          bottom: 0,
          pageIconColor: "#000000",
          pageIconInactiveColor: "#BDBDBD",
          pageTextStyle: {
            color: "#000000",
            fontFamily: "Poppins",
          },
          textStyle: {
            fontFamily: "Poppins",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["42%", "74%"],
            center: ["50%", "48%"],
            data: this.formattedChartData,
            label: {
              show: true,
              formatter: function (param) {
                return `${param.percent.toFixed(0)}%`;
              },
              fontFamily: "Poppins",
              fontSize: 11,
              color: "#ffffff",
              position: "inside",
            },
            labelLine: {
              show: false,
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.audience-pie-chart {
  height: 100%;
  /* min-height: 260px; */
  width: 100%;
}

.audience-pie-chart__canvas {
  height: 100%;
}

.chart {
  height: 100%;
  width: 100%;
}
</style>
